import { BLOCK_SIZE } from './typings';

export const getBlockSize = (width: number) => {
    if (width > 476) {
        return BLOCK_SIZE.L;
    }

    if (width > 391) {
        return BLOCK_SIZE.M;
    }

    return BLOCK_SIZE.S;
};

export const getMainBlockSize = (width: number) => {
    if (width > 1089) {
        return BLOCK_SIZE.XL;
    }

    if (width > 850) {
        return BLOCK_SIZE.L;
    }

    if (width > 760) {
        return BLOCK_SIZE.M;
    }

    return BLOCK_SIZE.S;
};
